import Vue from 'vue';
import Wizard from './components/Register/Wizard.vue'
import { Lang } from "laravel-vue-lang";
import axios from "axios";

Vue.use(Lang, {
    fallback: "en"
});

window.registerApp = new Vue({
    el: "#register-holder",
    components: {
        'register-wizard': Wizard
    },
    data () {
        return {
            coupon: false
        }
    },
    methods: {
        setCoupon: function(val) {
            console.log('coupon has new val ' + val);
            this.coupon = val;
        }
    }
});
